import React from 'react';
import { Input, Row, Col } from 'antd';

const EvaluationDeletedSearch = ({ evaluationData = [], setFilteredData, searchText, setSearchText }) => {

  const normalize = (v) => {
    if (v == null) return "";
    if (typeof v === "string") return v.toLowerCase();
    if (typeof v === "number") return String(v).toLowerCase();
    if (typeof v === "object") {
      if (v.name) return String(v.name).toLowerCase();
      if (v.title) return String(v.title).toLowerCase();
      // fallback: stringify small objects
      try {
        return JSON.stringify(v).toLowerCase();
      } catch {
        return "";
      }
    }
    return "";
  };

  const buildSearchableString = (record) => {
    // rutas alternativas para cada campo que puede venir distinto según la vista
    const parts = [];

    // código
    parts.push(normalize(record.code));
    // área
    parts.push(normalize(record.area?.name));
    // asset: puede venir en record.asset?.name o dentro de dependency_control.dependency.asset.name
    parts.push(normalize(record.asset?.name));
    parts.push(normalize(record.dependency_control?.dependency?.asset?.name));
    // dependencia: puede venir en dependency_control.dependency.name o record.dependency?.name
    parts.push(normalize(record.dependency_control?.dependency?.name));
    parts.push(normalize(record.dependency?.name));
    // control: puede venir en dependency_control.control.title o record.control?.title
    parts.push(normalize(record.dependency_control?.control?.title));
    parts.push(normalize(record.control?.title));
    // descripción del control (opcional)
    parts.push(normalize(record.dependency_control?.control?.description));
    parts.push(normalize(record.description));
    parts.push(normalize(record.control?.description));

    // status: puede venir como objeto {id,name}, como número, o como string
    if (typeof record.status === "object") {
      parts.push(normalize(record.status.name));
    } else {
      parts.push(normalize(record.status)); // número o string
    }

    // campos comunes adicionales que podrías querer buscar
    parts.push(normalize(record.user?.username));
    parts.push(normalize(record.tenant_name));
    parts.push(normalize(record.name)); // por si hay un nombre en raíz

    // devuelve todo concatenado (espacios para separar)
    return parts.filter(Boolean).join(" ");
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const text = (value || "").toLowerCase().trim();

    if (!text) {
      setFilteredData(evaluationData);
      return;
    }

    const filtered = (evaluationData || []).filter((record) => {
      const pool = buildSearchableString(record);
      return pool.includes(text);
    });

    setFilteredData(filtered);
  };

  const handleReset = () => {
    setSearchText('');
    setFilteredData(evaluationData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Evaluaciones"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default EvaluationDeletedSearch;
